import React from "react";
import { shape, string, arrayOf } from "prop-types";
import { List } from "./List";

const ListConnector = ({ data }) => (
	<List theme={data.theme} listStyle={data.listStyle}>
		{data.entries.map(entry => (
			<List.Item key={`${data.id}-${entry.replace(" ", "-")}`}>{entry}</List.Item>
		))}
	</List>
);

ListConnector.propTypes = {
	data: shape({
		id: string,
		theme: string,
		listStyle: string,
		entries: arrayOf(string),
	}),
};
ListConnector.defaultProps = {
	data: null,
};

export default ListConnector;
export { ListConnector };
